import styled from "styled-components";
import { Div } from 'components';
import Item from '../NavItem';

export const Wrapper = styled(Div)`
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  padding: 24px 0;

  @media(max-width: 920px){
    padding-top: 0;
  }
`;

export const NavLeft = styled.ul`
  display: flex;
  list-style-type: none;
  border: 1px solid ${({theme}) => theme.colors.gray[theme.borders[0]] };

  @media(max-width: 920px){
    margin-left: 16px;
    border: none;
  }
`;

export const NavItem = styled(Item)`
  border: ${({hasBorder, theme}) => !!hasBorder && `1px solid ${theme.colors[theme.background.tertiary.color][theme.background.tertiary.intensity]}`};
  padding: ${({hasBorder}) => {!!hasBorder && '10px 14px'}};
  border-radius: ${({hasBorder}) => !!hasBorder && '4px'};
  font-size: 14px;
  & + & {
    margin-left: ${({hasBorder}) => !!hasBorder ? '12px' : '0px' } 
  }

  @media(max-width: 920px){
    border: 1px solid white;
    border-radius: 2px;
    & + & {
      margin-left: 12px; 
    }
  }
`;